export enum TypeStatusIconMobileMenu {
    default,
    return
}
